import React, { useState } from 'react';
import { Building2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import { $api } from '../../api';
import ErrorMessage from '../ErrorMessage';
import SuccessMessage from '../SuccessMessage';

const PasswordLost: React.FC = () => {
  const [email, setEmail] = useState('');
  const [success, setSuccess] = useState(false);

  const resetMutation = $api.useMutation('post', '/api/auth/password-reset');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    resetMutation.mutate(
      { body: { email } },
      { onSuccess: () => setSuccess(true) }
    );
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        {/* Logo and Title */}
        <div className="text-center mb-8">
          <div className="flex justify-center mb-4">
            <div className="bg-blue-600 p-3 rounded-full">
              <Building2 className="h-8 w-8 text-white" />
            </div>
          </div>
          <h1 className="text-3xl font-bold text-gray-900 mb-2">KYC Pro</h1>
          <p className="text-gray-600">Réinitialiser votre mot de passe</p>
        </div>

        {/* Form */}
        <div className="bg-white rounded-lg shadow-lg p-8">
          {resetMutation.error && (
            <ErrorMessage error={resetMutation.error} className="mb-4" />
          )}

          {success ? (
            <div>
              <SuccessMessage 
                message="Un email de réinitialisation a été envoyé à votre adresse. Veuillez vérifier votre boîte de réception." 
                className="mb-4" 
              />
              <Link
                to="/auth"
                className="block w-full text-center bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors"
              >
                Retour à la connexion
              </Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <p className="text-sm text-gray-600 mb-4">
                  Entrez votre adresse email et nous vous enverrons un lien pour réinitialiser votre mot de passe.
                </p>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Adresse email
                </label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="votre@email.com"
                  required
                />
              </div>

              <button
                type="submit"
                disabled={resetMutation.isPending}
                className="w-full bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {resetMutation.isPending ? (
                  <div className="flex items-center justify-center">
                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                    Envoi...
                  </div>
                ) : (
                  'Envoyer le lien de réinitialisation'
                )}
              </button>

              <div className="text-center text-sm text-gray-600">
                <Link to="/auth" className="text-blue-600 hover:text-blue-500 font-medium">
                  Retour à la connexion
                </Link>
              </div>
            </form>
          )}
        </div>

        {/* Footer */}
        <div className="text-center mt-8 text-sm text-gray-500">
          <p>&copy; 2025 KYC Pro. Tous droits réservés.</p>
        </div>
      </div>
    </div>
  );
};

export default PasswordLost;
